import React, { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { FeatureGates, useFeatureGate } from '@services/statsig';

const RedesignTestBanner = lazy(() =>
  import('@features/redesign-test-banner').then(m => ({ default: m.RedesignTestBanner })),
);

export const NoteRoute: React.FC = () => {
  // Gate the lazy-loaded banner here so users not in the test don't fetch the
  // banner module. The banner self-checks the same gate, so mounting it would
  // be safe — this is purely a fetch-avoidance optimization.
  const isV3TestEnabled = useFeatureGate(FeatureGates.PATIENT_PAGE_V3_TEST_2026_05);

  return (
    <>
      {isV3TestEnabled && (
        <Suspense fallback={null}>
          <RedesignTestBanner surface="note_page" />
        </Suspense>
      )}
      <Outlet />
    </>
  );
};
